/**
 * @module api-web:financialAffairs/generalLedger/data/voucherTemplate
 */
import service from '@/service'

/**
 * 查询 财务-总账-资料-凭证模板
 * @param {object} params
 */
export function getList(params) {
  return service['api-web']({
    url: '/fin/gl/data/finAccountVoucherTemplate/getList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
